// GiftShip carousel override - ONLY FOR SPECIFIC CAROUSEL
function overrideSpecificGiftShipCarousel() {
  const SCROLL_PIXELS = 355.333;
  
  // ✅ ONLY target carousels with this specific data-option-id
  const specificCarousels = document.querySelectorAll('[data-option-id="ddfc901b-f5a3-4594-8cf3-107d630702be"]');
  
  specificCarousels.forEach(specificCarousel => {
    // ✅ Find buttons ONLY within this specific carousel
    const rightButtons = specificCarousel.querySelectorAll('.gs__carousel-arrow-btn--right');
    const leftButtons = specificCarousel.querySelectorAll('.gs__carousel-arrow-btn--left');
    
    console.log('Found specific carousel with buttons:', {
      right: rightButtons.length,
      left: leftButtons.length
    });

    rightButtons.forEach(btn => {
      // Skip if already processed
      if (btn.hasAttribute('data-custom-handler')) return;
      
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      newBtn.setAttribute('data-custom-handler', 'true');
      
      newBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();     
        
        const carousel = this.closest('.gs__carousel-wrapper').querySelector('.gs__carousel');
        if (!carousel) return;
        
        console.log('Right button clicked on specific carousel');
        
        const currentTransform = carousel.style.transform;
        const currentX = currentTransform ? parseFloat(currentTransform.match(/translateX\(([^)]+)px\)/)[1]) || 0 : 0;
        const carouselWidth = carousel.scrollWidth;
        const containerWidth = carousel.parentElement.offsetWidth;
        const maxTranslateX = -(carouselWidth - containerWidth);
        
        let newX = currentX - SCROLL_PIXELS;
        if (newX < maxTranslateX) newX = maxTranslateX;
        
        carousel.style.transform = `translateX(${newX}px)`;
        
        const leftBtn = this.closest('.gs__carousel-wrapper').querySelector('.gs__carousel-arrow-btn--left');
        const rightBtn = this;
        
        leftBtn.disabled = newX === 0;
        rightBtn.disabled = newX <= maxTranslateX;
      });
    });

    leftButtons.forEach(btn => {
      // Skip if already processed
      if (btn.hasAttribute('data-custom-handler')) return;
      
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      newBtn.setAttribute('data-custom-handler', 'true');
      
      newBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const carousel = this.closest('.gs__carousel-wrapper').querySelector('.gs__carousel');
        if (!carousel) return;
        
        console.log('Left button clicked on specific carousel');
        
        const currentTransform = carousel.style.transform;
        const currentX = currentTransform ? parseFloat(currentTransform.match(/translateX\(([^)]+)px\)/)[1]) || 0 : 0;
        
        let newX = currentX + SCROLL_PIXELS;
        if (newX > 0) newX = 0;
        
        carousel.style.transform = `translateX(${newX}px)`;
        
        const leftBtn = this;
        const rightBtn = this.closest('.gs__carousel-wrapper').querySelector('.gs__carousel-arrow-btn--right');
        
        leftBtn.disabled = newX === 0;
        rightBtn.disabled = newX <= -(carousel.scrollWidth - carousel.parentElement.offsetWidth);
      });
    });
  });
}

// Initialize only for specific carousel
document.addEventListener('DOMContentLoaded', overrideSpecificGiftShipCarousel);

// Watch only for specific carousel changes
let lastSpecificCarouselCount = 0;
setInterval(() => {
  const currentSpecificCarouselCount = document.querySelectorAll('[data-option-id="ddfc901b-f5a3-4594-8cf3-107d630702be"]').length;
  if (currentSpecificCarouselCount !== lastSpecificCarouselCount) {
    lastSpecificCarouselCount = currentSpecificCarouselCount;
    console.log('Specific carousel count changed:', currentSpecificCarouselCount);
    setTimeout(overrideSpecificGiftShipCarousel, 100);
  }
}, 500);